import * as url from "../url.helper";

import { post } from "../api.helper";

export const addSMSTemplate = data => post(url.ADD_SMS_TEMPLATE, data);

export const getSMSTemplate = data => post(url.GET_SMS_TEMPLATE_LIST, data);

export const getTemplateSMS = data => post(url.GET_SMS_TEMPLATE, data);

export const editSMSTemplate = data => post(url.EDIT_SMS_TEMPLATE, data);